<template>
  <div class="modal" :class="show? 'show': ''" :style="show? 'display:block;': ''" aria-hidden="true" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form role="form" @submit.prevent="eventSubmit" class="col-md-12">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="eventCalendar">Select Calendar</label>
                <select id="eventCalendar" v-model="calendar_id" class="form-control">
                  <option v-for="calendar in calendars" :key="calendar.id" :value="calendar.id"> {{ calendar.name }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label for="eventSubject">Add a title</label>
                <input type="text" v-model="event.subject" class="form-control" id="eventSubject" name="eventSubject" placeholder="Add a title">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label>Invite attendees</label>
                <v-select taggable multiple no-drop v-model="attendees" class="crm-multiselect" id="eventInviteAttendee"/>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <label for="eventStartDate">Event start date</label>
                <datepicker v-model="eventStartDate" id="eventStartDate" name="eventStartDate" :input-class="['form-control']" :format="dateFormat"
                            @input="selectStartDate" :use-utc="true"></datepicker>
              </div>
              <div class="form-group col-md-4">
                <label for="eventStartTime">Event start time</label>
                <vue-timepicker id="eventStartTime" close-on-complete v-model="timePicker.start" hide-clear-button/>
              </div>
              <div class="form-group col-md-4">
                <label for="eventEndTime">Event end time</label>
                <vue-timepicker id="eventEndTime" close-on-complete v-model="timePicker.end" hide-clear-button/>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="eventRepeat">Repeat</label>
                <select id="eventRepeat" v-model="repeat" class="form-control">
                  <option value="never" selected>Repeat: Never</option>
                  <option value="daily">Every day</option>
                  <option value="weekly">Every week</option>
                  <option value="monthly">Every month</option>
                  <option value="yearly">Every year</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="eventReminder">Reminder</label>
                <select id="eventReminder" v-model="event.reminderMinutesBeforeStart" class="form-control">
                  <option value="0">Remind: Never</option>
                  <option value="15" selected>15 mins before</option>
                  <option value="30">30 mins before</option>
                  <option value="45">45 mins before</option>
                  <option value="60">1 hour before</option>
                  <option value="120">2 hours before</option>
                  <option value="180">3 hours before</option>
                  <option value="240">4 hours before</option>
                  <option value="300">5 hours before</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="eventLocation">Location</label>
                <input type="text" class="form-control" id="eventLocation" name="eventLocation" placeholder="Location" v-model="event.location.displayName">
              </div>
              <div class="form-group col-md-6">
                <label for="eventOnline">Online Meeting</label>
                <select id="eventOnline" v-model="onlineMeeting" class="form-control">
                  <option value="">No online meeting</option>
                  <option value="teamsForBusiness" selected>Team for business</option>
                  <option value="skypeForBusiness">Skype for business</option>
                  <option value="skypeForConsumer">Skype for customer</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label for="eventDescription">Add a description</label>
                <textarea class="form-control" id="eventDescription" rows="5" name="eventDescription" placeholder="Add a description" v-model="event.body.content"/>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="saveEvent()">Save</button>
          <button type="button" class="btn btn-primary" :style="isEmpty(info.event)? 'display:none;': 'display:block;'" @click="deleteEvent()">Delete</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  name: 'EventModal',
  components: {
    vSelect,
    Datepicker,
    VueTimepicker
  },
  props: {
    show: Boolean,
    info: Object
  },
  data() {
    return {
      title: "",
      event: {
        subject: '',
        attendees: [],
        start: {
          dateTime: "",
          timeZone: "Europe/London"
        },
        end: {
          dateTime: "",
          timeZone: "Europe/London"
        },
        recurrence: {},
        reminderMinutesBeforeStart: 15,
        isReminderOn: true,
        location: {
          displayName: ""
        },
        body: {
          contentType: "text",
          content: ""
        },
        isOnlineMeeting: false,
        onlineMeetingProvider: null,
      },
      defaultEvent: {
        subject: '',
        attendees: [],
        start: {
          dateTime: "",
          timeZone: "Europe/London"
        },
        end: {
          dateTime: "",
          timeZone: "Europe/London"
        },
        recurrence: {},
        reminderMinutesBeforeStart: 15,
        isReminderOn: true,
        location: {
          displayName: ""
        },
        body: {
          contentType: "text",
          content: ""
        },
        isOnlineMeeting: false,
        onlineMeetingProvider: null,
      },
      calendar_id: null,
      time: {
        startDate: this.$moment.utc(new Date()).format("YYYY-MM-DD"),
        endDate: this.$moment.utc(new Date()).format("YYYY-MM-DD"),
      },
      timePicker: {
        start: "00:00",
        end: "00:30"
      },
      repeat: "never",
      onlineMeeting: "",
      attendees: [],
      calendars: [],
      eventStartDate: this.$moment.utc(new Date()).format("YYYY-MM-DD"),
      realEventObject: {},
    }
  },
  mounted() {
    this.calendars = this.info.calendars;
    this.calendar_id = this.info.calendar_id;
    if (this.isEmpty(this.info.event)) {
      this.title = "Create new event";
      this.event = this.defaultEvent;
      this.eventStartDate = this.info.selectedDate;
      this.setDefaultEvent();
    }
    else {
      this.title = "Edit event";
      this.realEventObject = this.info.event;
      if (this.info.event.seriesMasterId) {
        let that = this;
        axios.get(this.crmApiPath + 'msgraph/calendar/' + this.calendar_id + '/events/' + this.info.event.seriesMasterId).then(response => {
          if (response.data.is_redirect) {
            window.location.href = response.data.redirect_url;
          }
          else {
            that.realEventObject = response.data.event.data;
            that.setMasterEvent(that.realEventObject);
          }
        }).catch(error => console.log(error));
      }
      else {
        this.setEvent(this.info.event);
      }
    }
  },
  methods: {
    setEvent(event) {
      this.event.subject = event.subject;
      this.attendees = event.attendees.map(function (element) {
        return element.emailAddress.address;
      });
      this.eventStartDate = this.$moment.utc(new Date(event.start.dateTime)).format("YYYY-MM-DD");
      this.time.startDate = this.eventStartDate;
      this.time.endDate = this.eventStartDate;
      this.timePicker.start = this.$moment.utc(new Date(event.start.dateTime)).format("HH:mm");
      this.timePicker.end = this.$moment.utc(new Date(event.end.dateTime)).format("HH:mm");
      this.repeat = "never";
      this.event.reminderMinutesBeforeStart = event.reminderMinutesBeforeStart;
      this.event.location.displayName = event.location.displayName;
      if (event.isOnlineMeeting) {
        this.onlineMeeting = event.onlineMeetingProvider;
      }
      else {
        this.onlineMeeting = "";
      }
      this.event.body.content = event.bodyPreview;

    },
    setMasterEvent(event) {
      this.event.subject = event.subject;
      this.attendees = event.attendees.map(function (element) {
        return element.emailAddress.address;
      });
      this.eventStartDate = this.$moment.utc(new Date(event.start.dateTime)).format("YYYY-MM-DD");
      this.time.startDate = this.eventStartDate;
      this.time.endDate = this.eventStartDate;
      this.timePicker.start = this.$moment.utc(new Date(event.start.dateTime)).format("HH:mm");
      this.timePicker.end = this.$moment.utc(new Date(event.end.dateTime)).format("HH:mm");

      this.repeat = event.recurrence.pattern.type;
      this.event.reminderMinutesBeforeStart = event.reminderMinutesBeforeStart;
      this.event.location.displayName = event.location.displayName;
      if (event.isOnlineMeeting) {
        this.onlineMeeting = event.onlineMeetingProvider;
      }
      else {
        this.onlineMeeting = "";
      }
      this.event.body.content = event.bodyPreview;
    },
    setDefaultEvent() {
      this.realEventObject = {};
      this.attendees = [];
      this.timePicker.start = "00:00";
      this.timePicker.end = "00:30";
      this.repeat = "never";
      this.onlineMeeting = "";
      this.time.startDate = this.info.selectedDate;
      this.time.endDate = this.info.selectedDate;
    },
    eventSubmit() {

    },
    createEvent() {
      let that = this;
      axios.post(this.crmApiPath + 'msgraph/calendar/' + this.calendar_id + '/events', this.event).then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          that.$emit('close');
        }
      }).catch(error => console.log(error));
    },
    updateEvent() {
      let that = this;
      axios.patch(this.crmApiPath + 'msgraph/calendar/' + this.calendar_id + '/events/' + this.realEventObject.id, this.event).then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          that.$emit('close');
        }
      }).catch(error => console.log(error));
    },
    saveEvent() {
      this.event.start.dateTime = this.time.startDate + this.getTimeFormat(this.timePicker.start);
      this.event.end.dateTime = this.time.endDate + this.getTimeFormat(this.timePicker.end);
      this.event.recurrence = this.getRecurrenceObject(this.repeat);
      if (this.onlineMeeting === "") {
        this.event.isOnlineMeeting = false;
      }
      else {
        this.event.isOnlineMeeting = true;
        this.event.onlineMeetingProvider = this.onlineMeeting;
      }
      this.event.attendees = this.getAttendeesObject(this.attendees);

      if (this.isEmpty(this.info.event)) {
        this.createEvent();
      }
      else {
        this.updateEvent();
      }
    },
    deleteEvent() {
      let that = this;
      axios.delete(this.crmApiPath + 'msgraph/calendar/' + this.calendar_id + '/events/' + this.realEventObject.id).then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          that.$emit('close');
        }
      }).catch(error => console.log(error));
    },
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    selectStartDate(startDate) {
      if (startDate != null) {
        this.time.startDate = this.$moment.utc(startDate).format('YYYY-MM-DD');
        this.time.endDate = this.$moment.utc(startDate).format('YYYY-MM-DD');
      }
    },
    getTimeFormat(str) {
      return "T" + str + ":00.0000000";
    },
    getRecurrenceObject(str) {
      if (str === "never") {
        return null;
      }
      else if (str === "daily") {
        return {
          pattern: {
            type: "daily",
            interval: 1
          },
          range: this.getGeneralRange()
        };
      }
      else if (str === "weekly") {
        return {
          pattern: {
            type: "weekly",
            interval: 1,
            daysOfWeek: [this.getWeekString(this.time.startDate)]
          },
          range: this.getGeneralRange()
        };
      }
      else if (str === "monthly") {
        return {
          pattern: {
            type: "absoluteMonthly",
            interval: 1
          },
          range: this.getGeneralRange()
        };
      }
      else if (str === "yearly") {
        return {
          pattern: {
            type: "absoluteYearly",
            interval: 1
          },
          range: this.getGeneralRange()
        };
      }
      else {
        return null;
      }
    },
    getGeneralRange() {
      return {
        type: "noEnd",
        startDate: this.time.startDate
      };
    },
    getWeekString(date) {
      const dayOfWeek = new Date(date).getDay();
      return isNaN(dayOfWeek) ? null : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
    },
    getAttendeesObject(obj) {
      let that = this;
      return obj.filter(function (elem) {
        return that.validateEmail(elem);
      }).map(function (elem) {
        return {
          emailAddress: {
            address: elem,
          },
          type: "required"
        }
      });
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    isEmpty(obj) {
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop))
          return false;
      }
      return true;
    }
  },
}
</script>
<style scoped lang="scss">
.modal-dialog {
  min-height:      calc(100vh - 60px);
  display:         flex;
  flex-direction:  column;
  justify-content: center;
  overflow:        auto;
}

@media(max-width: 768px) {
  .modal-dialog {
    min-height: calc(100vh - 20px);
  }
}
</style>
<style lang="scss">

</style>
